import { required, confirmed, email } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import i18n from '@/i18n.js'

extend('required', {
  ...required,
  message: i18n.t('formError.fieldRequired')
})

extend('email', {
  ...email,
  message: i18n.t('formError.emailInvalid')
})

extend('password', {
  validate: (value) => {
    return value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]+).{6,}$/gm)
  },
  message: i18n.t('formError.PasswordRequiresUpper')
})

extend('confirmed', {
  ...confirmed,
  message: i18n.t('formError.passwordMustMatch')
})

extend('min', {
  validate: (value, args) => {
    return value.length >= args.length
  },
  params: ['length'],
  message: (_, value) => i18n.t('formError.minLength', { num: value.length })
})

extend('max', {
  validate: (value, args) => {
    return value.length <= args.length
  },
  params: ['length'],
  message: (_, value) => i18n.t('formError.maxLength', { num: value.length })
})
